import { createQueryKeys } from "@lukemorales/query-key-factory";
import { queryOptions, useQuery, useQueryClient } from "@tanstack/react-query";

import { useMutationWithError } from "@/hooks";
import { adminApi } from "@/lib/api";

import { type AdminMood } from "../types";

export type MoodList = AdminMood<true>[];

export const moods = createQueryKeys("admin-moods", {
  all: null,
});

const include = "reasons";

export const fetchMoodsQueryOptions = () =>
  queryOptions({
    ...moods.all,
    queryFn: () =>
      adminApi
        .get<MoodList>(`/mood?include=${include}`, {
          params: { include },
        })
        .then((response) => response.data),
  });

export const useFetchMoods = () => useQuery(fetchMoodsQueryOptions());

export interface MoodUserRequest {
  moods: Array<{
    id?: number | null;
    name: string;
    emoji: string;
    reasons: Array<{
      id?: number | null;
      reason: string;
    }>;
  }>;
}

export const useUpdateMoods = () => {
  const queryClient = useQueryClient();
  return useMutationWithError({
    mutationFn: (data: MoodUserRequest) =>
      adminApi
        .put(`/mood?include=${include}`, data)
        .then((response) => response.data),
    onSuccess: () => {
      queryClient.invalidateQueries(moods.all);
    },
  });
};
